import React, { useContext, useEffect, useState } from 'react';
import { getTeachers, getStudentsList, createGroups, createStudentGroups } from '../../../actions';
import { Tabs } from 'antd';
import GroupsAdd from './GroupsAdd';
import GroupsTable from './GroupsTable';
import { Context } from '../../../defaults';

const Groups = () => {
  const { dictionary, language, setLoading } = useContext(Context);
  const { TabPane } = Tabs;
  const [students, setStudents] = useState();
  const [added, setAdded] = useState(false);
  const [active, setActive] = useState('1');


  useEffect(() => {
    getStudentsList().then(({ data }) => setStudents(data));
  }, []);



  const callback = (key) => {
    setActive(key);
    setAdded(false);
  };

  return (
    <Tabs defaultActiveKey='1' activeKey={active} onChange={callback}>
      <TabPane tab={`${dictionary?.CreateGroup[language]}`} key='1'>
        <GroupsAdd
          setAdded={setAdded}
          students={students}
          setActive={setActive}
        />
      </TabPane>
      <TabPane tab={dictionary?.GroupsList[language]} key='2'>
        <GroupsTable added={added} setAdded={setAdded} />
      </TabPane>
    </Tabs>
  );
}

export default Groups;
